import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Record } from "appworks/model/gameplay/records/record";
import { PartnerConnectConfigRecordBuilder } from "partner-connect/integration/builders/records/partner-connect-config-record-builder";
import { PartnerConnect } from "partner-connect/partner-connect-manager";

export class TGRPartnerConnectConfigRecordBuilder extends PartnerConnectConfigRecordBuilder {

    public build(gameplay: Gameplay, request: any, config: PartnerConnect.SlotGameConfig): Record[] {

        // PartnerConnectManager.OVERRIDE_AUTOPLAY_COUNTS = {
        //     defaultIndex: 2,
        //     normal: [10, 20, 30, 50, Infinity],
        //     lossLimitEnabled: [10, 20, 30, 50, 100]
        // };

        return super.build(gameplay, request, config);
    }
}

export const tgrPartnerConnectConfigRecordBuilder = new TGRPartnerConnectConfigRecordBuilder();
